import { React } from "react";

import adultBalletSm from "../assets/summerIntensivesPage/claudia-and-linda-300.jpg";
import adultBalletMd from "../assets/summerIntensivesPage/claudia-and-linda-768.jpg";
import adultBalletLg from "../assets/summerIntensivesPage/claudia-and-linda-1280.jpg";
import adultBalletXL from "../assets/summerIntensivesPage/claudia-and-linda-2000.jpg";
import Footer from "../components/Footer";

import nybcAlondraSm from "../assets/nybc/nybc-alondra-300.jpg";
import nybcAlondraMd from "../assets/nybc/nybc-alondra-768.jpg";
import nybcAlondraLg from "../assets/nybc/nybc-alondra-1280.jpg";
import nybcAlondraXL from "../assets/nybc/nybc-alondra-2000.jpg";
import nbcCinRehearsalsSm from "../assets/nbc/nbcCinRehearsals-300.jpg";
import nbcCinRehearsalsMd from "../assets/nbc/nbcCinRehearsals-768.jpg";
import nbcCinRehearsalsLg from "../assets/nbc/nbcCinRehearsals-1280.jpg";
import nbcCinRehearsalsXL from "../assets/nbc/nbcCinRehearsals-2000.jpg";
import nbycHandbook from "../assets/nybc/Nylia Ballet Youth Company Handbook 2026-2027.pdf";
import competitionHandbook from "../assets/competitions/CompetitionHandbook26-27.pdf";

import NyliaButton from "./nyliaButton/NyliaButton.js";
import Accordion from "react-bootstrap/Accordion";

import "./NBC.css";

function NBYC() {
  var jotformLink = "https://form.jotform.com/252657673602159";

  const goToSection = (sectionId) => {
    document.getElementById(sectionId).scrollIntoView(false);
  };

  return (
    <div class="main-container" id="nbyc">
      <div className="main-img-bkg" id="mission-section">
        <div className="main-title">
          <h1>NYLIA BALLET YOUTH COMPANY</h1>
        </div>
        <div className="main-box">
          <h1>Nylia Ballet's Youth Performing Company</h1>
          <h2>Our Mission</h2>
          <p>
            <br />
            At Nylia Ballet Youth Company, we inspire and cultivate a vibrant
            community of dancers and enthusiasts by embracing ballet's
            transformative power. Our Company consists of dancers who work
            full-time, non-dance jobs but still train professionally. We believe
            ballet is for everyone. Thus, by offering diverse artistic
            performances and outreach programs, we strive to share the beauty of
            dance and enrich the cultural heritage of the El Paso Borderland
            community. Our mission is to foster a community that reflects the
            diversity of our world, welcoming anyone who wishes to participate,
            regardless of age, skills, or experience.
          </p>
          {/* <a href="/companydancers">
            <NyliaButton label={"Our Dancers"}></NyliaButton>
          </a> */}
          <p>
            <br />
            <br />
            Turning 18? Join our parent company, Nylia Ballet Company!
          </p>
          <a href="/nyliaballetcompany">
            <NyliaButton label={"Nylia Ballet Company"}></NyliaButton>
          </a>
        </div>
      </div>

      <div className="main-img-bkg" id="nybc-section">
        <div className="main-box">
          <div className="main-img">
            <img
              src={nybcAlondraSm}
              srcSet={`${nybcAlondraSm} 300w, ${nybcAlondraMd} 768w, ${nybcAlondraLg} 1280w, ${nybcAlondraXL} 2000w`}
              className="w-100 shadow-1-strong rounded mb-4"
              alt="El Paso Ballet Nylia Ballet Academy School for Classical Ballet performing in nylia ballet company productions"
            />
          </div>
          <h1 id="highlightTitle">NYLIA BALLET YOUTH COMPANY</h1>

          <p>
            <br />
            Through collaborations that expand the accessibility and
            appreciation of the arts, we cultivate a rich tapestry of creativity
            within our community. We believe in providing the highest level of
            classical ballet training and performance opportunities, nurturing
            each individual to reach their unique potential in an environment of
            self-discipline, creativity, and respect. Nylia Ballet Youth Company
            dancers perform throughout the year, on our main stage, at outreach
            events, festivals, workshops and other events around the El Paso
            area and beyond. Weekly schedules will include company classes,
            rehearsals, coaching, career/professionalism counseling and
            training, resume/audition packet creation, technique class, pointe,
            variations, partnering, and modern, as well as other classes,
            performances, appearances and events.
            <br /> <br />
            <NyliaButton
              label={"YOUTH COMPANY MEMBER HANDBOOK"}
              link={nbycHandbook}
            ></NyliaButton>
            <br></br>
            <div className="shadow-box">
              <Accordion flush>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    <b id="highlightTitle">
                      NYLIA BALLET YOUTH COMPANY - MEMBER EXCLUSIVES
                    </b>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      <u>TRAINING</u>
                      <ul>
                        <li>
                          Receive professionalization and mock training for
                          interviews, auditions, etc. <br />
                        </li>
                        <li>
                          Priority access to private training. <br />
                        </li>
                        <li>
                          Comprehensive ballet curriculum. <br />
                        </li>
                        <li>
                          Access to staff. <br />
                        </li>
                        <li>
                          A remarkable facility. <br />
                        </li>
                        <li>
                          As a Nylia Ballet Youth Company member, the $350
                          Summer Intensive tuition is fully waived. Enjoy
                          advanced summer training at no additional cost!
                        </li>
                      </ul>
                      <u>PERFORMING</u>
                      <ul>
                        <li>
                          Gain access to a company staging new and notable
                          repertory.
                        </li>
                        <li>
                          Company dancers gain exposure to creative processes
                          through new original works while fine-tuning
                          foundational and historical classical ballets. <br />
                        </li>
                        <li>
                          In all our performances, young dancers are given
                          opportunities to work with professionals to learn
                          about the world of classical ballet and performing.{" "}
                          <br />
                        </li>
                      </ul>
                      <u>COMPETITION</u>
                      <ul>
                        <li>
                          Select and eligible Youth Company members are invited
                          to compete in nationwide competitions, including YAGP.
                        </li>
                      </ul>
                      <u>EXTRA PERKS</u>
                      <ul>
                        <li>
                          Participate in Nylia Ballet Company marketing
                          photoshoots. <br />
                        </li>
                        <li>
                          Headshot featured in every program for Nylia Ballet
                          Company productions. <br />
                        </li>
                        <li>20% discount on Academy tuition.</li>
                      </ul>
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    <b id="highlightTitle">REQUIREMENTS</b>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      <li>Ages 7 - 18</li>
                      <li>
                        All Nylia Ballet Company dancers must be enrolled under
                        the <b>Unlimited Classes </b>option. The contract will
                        specify which classes are mandatory for each dancer and
                        which classes are recommended. Dancers are encouraged to
                        take as many classes as possible to maximize their
                        training and growth.
                      </li>
                      <li>
                        All Nylia Ballet Youth Company members must take Company
                        class once a week.
                      </li>
                      <li>
                        As leaders of the school, company members are expected
                        to take part in assistant teaching younger levels &
                        costume/set-work as needed.
                      </li>
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    <b id="highlightTitle">FEES</b>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      In an effort to keep tuition costs consistent, additional
                      fees are required in order to produce and present high
                      quality productions for Youth company dancers to
                      participate in.
                      <br />
                      <br />
                      <li>
                        Youth Company members receive a 20% discount on their
                        tuition for Nylia Ballet Academy.
                      </li>
                      <li>
                        As a Nylia Ballet Youth Company member, the $350 Summer
                        Intensive tuition is fully waived. Enjoy advanced summer
                        training at no additional cost!
                      </li>
                      <li>
                        Company members are not charged for time spent in
                        rehearsals.
                      </li>
                      <li>
                        Company members are charged a $40 registration fee.
                      </li>
                      <li>
                        Limited merit-based scholarships are available and
                        distributed in conjunction with acceptance.
                      </li>
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    <b id="highlightTitle">IMPORTANT DATES</b>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      <b>Nylia Ballet Youth Company: 2026 - 2026 Season</b>
                      <ul>
                        <li>May 3rd, 2026 - May 2nd, 2027</li>
                      </ul>
                      <b>Nylia Ballet Youth Company Auditions</b>
                      <ul>
                        <li>
                          April 26th, 2026 at 11:00 am - Nylia Ballet Academy
                        </li>
                      </ul>
                      <b>Summer Concerto</b>
                      <ul>
                        <li>July 2026</li>
                      </ul>
                      <b>Nylia Ballet Youth Company Trainee Auditions</b>
                      <ul>
                        <li>
                          To be Announced
                          {/* September 28th, 2025 at 10:00 am - Nylia Ballet
                          Academy */}
                        </li>
                      </ul>
                      <b>The Land of the Sweets</b>
                      <ul>
                        <li>2026-2027</li>
                      </ul>
                      <b>Giselle</b>
                      <ul>
                        <li>2027</li>
                      </ul>
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          </p>
          <NyliaButton label={"Apply Now"} link={jotformLink}></NyliaButton>
        </div>
      </div>
      <div className="main-img-bkg" id="auditions-nbc">
        <div className="main-box">
          <h1 id="highlightTitle">YOUTH COMPANY AUDITIONS</h1>
          <h2>Join the Nylia Ballet Youth Company!</h2>
          <p>
            <br></br>
            Join us for auditions! We are accepting dancers of all levels of
            experience, from absolute beginner to advanced, ages 7+!
          </p>
          <hr></hr>
          <h2>NYLIA BALLET YOUTH COMPANY AUDITIONS</h2>
          <p>
            April 26, 2026
            <br />
            11:00 am - 12:30 pm
            <hr></hr>
          </p>
          <h2>TRAINEE AUDITIONS</h2>
          <p>
            {/* September 28, 2025 */}To be Announced
            {/* <br /> */}
            {/* <br /> */}
            {/* 10:00 am - 12:30 pm */}
            <hr></hr>
          </p>
          <h2>AUDITION REQUIREMENTS</h2>
          <p>
            A $10 Youth Company audition fee is due prior to the audition.
            <br />A <b>mandatory</b> parent meeting will take place at Nylia
            Ballet Academy during the audition from 12:00 pm - 12:30 pm.
            <br />
          </p>
          <NyliaButton
            label={"Register for Youth Company Auditions"}
            link={jotformLink}
          ></NyliaButton>
        </div>
      </div>
      <div className="main-img-bkg" id="nbc-section">
        <div className="main-box">
          <h1 id="highlightTitle">CLASSICAL BALLET COMPETITIONS</h1>
          <h2>Nylia Ballet Company's Competition Team</h2>

          <p>
            <br />
            The Nylia Ballet Youth Company’s Competition Program is comprised of
            select Nylia Ballet Company & Youth Company students chosen to
            represent the Company with excellence and professionalism. Dancers
            are invited to join based on their level, age, and their ability to
            meet the technical, physical, and emotional standards required for
            competitive performance. These dedicated students participate in
            focused one-on-one and group coaching sessions with experienced
            faculty, designed to enhance their technique, refine their artistry,
            and build performance confidence under high-pressure conditions.
            Through this rigorous training process, participants prepare to
            compete at renowned regional and national ballet competitions,
            gaining invaluable stage experience and exposure to the broader
            dance community.
            <br /> <br />
          </p>

          <NyliaButton
            label={"COMPETITION PROGRAM HANDBOOK"}
            link={competitionHandbook}
          ></NyliaButton>
          <br></br>
        </div>
      </div>
      <div className="main-img-bkg-2" id="nbc-footer">
        <div className="main-box centered">
          <p>
            At Nylia Ballet Company, we believe in the power of dance to
            inspire, uplift, and connect individuals across all boundaries. Our
            goal is to cultivate a community of dancers and enthusiasts who
            share a passion for artistic excellence and cultural enrichment.
            <br />
            <br />
            With a dedication to artistic integrity, social responsibility, and
            collaboration, Nylia Ballet Company enriches the lives of our
            audience members, performers, and community alike. Together we
            create moments of beauty, inspiration, and joy that resonate far
            beyond the stage.
            <br />
            <br />
            For more information please contact us at{" "}
            <b>info@nyliaballetacademy.com</b>.<br></br>
            <br></br>
          </p>
          <h3>
            Nylia Ballet Company<br></br> Illuminating the El Paso community,
            one dance at a time.
          </h3>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default NBYC;
